import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";
import getPrettyNumber from "../../../../helpers/getPrettyNumberFormat";

function BroadGnomad({ item }) {
  const fr = item.data.AC / item.data.AN;
  const isFreq = !Number.isNaN(fr);
  const computedFreq = isFreq ? getPrettyNumber(fr) : null;
  const alleleFreq = item.data.AF ?? computedFreq;

  return (
    <div className="tw-px-1 tw-py-px">
      <div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-20">Frequency</div>
          <div>{alleleFreq}</div>
          {isFreq ? (
            <div className="tw-flex">
              <div className="tw-w-1" />
              ≈
              <div className="tw-w-1" />
              <div
                className="tw-px-0.5"
                data-tooltip="allele count"
                data-tooltip-class="genome-browser-small-tooltip"
              >
                {item.data.AC}
              </div>
              <div className="tw-font-bold">/</div>
              <div
                className="tw-px-0.5"
                data-tooltip="allele number"
                data-tooltip-class="genome-browser-small-tooltip"
              >
                {item.data.AN}
              </div>
              <div className="tw-w-1" />
              =
              <div className="tw-w-1" />
              <div
                className="tw-opacity-80 tw-italic"
                data-tooltip="Allele number / Allele count"
                data-tooltip-class="genome-browser-small-tooltip"
              >
                (Allele count / Allele number)
              </div>
              <div className="tw-w-1" />
            </div>
          ) : null}
          <div className="tw-flex-grow" />
        </div>
      </div>
    </div>
  );
}

BroadGnomad.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

BroadGnomad.defaultProps = {};

export default BroadGnomad;
